import React, { useState } from "react";
import { FreeSwitchDevelopersFaqs } from "../../../components/faqData.js";
import ContactUs from "../../../components/ContactUs.js";
import { Helmet } from "react-helmet-async";

const pointsData = [
  {
    title: "Unified Communication Platform",
    content:
      "FreeSWITCH provides a unified communication platform, enabling seamless integration of voice, video, and messaging services. This empowers businesses to manage all interactions in a single, efficient system, enhancing productivity and collaboration.",
  },
  {
    title: "Scalable and Flexible Solutions",
    content:
      "With FreeSWITCH, businesses can scale their communication infrastructure as they grow. Its flexibility allows customization to meet specific business requirements, whether for a small startup or a large enterprise.",
  },
  {
    title: "Cost-Effective Communication",
    content:
      "By leveraging FreeSWITCH, organizations can significantly reduce their communication costs. Its open-source nature eliminates expensive licensing fees, and its efficient design ensures optimized resource utilization.",
  },
  {
    title: "Enhanced Collaboration Features",
    content:
      "FreeSWITCH offers advanced collaboration tools such as high-quality video conferencing, screen sharing, and real-time chat. These features foster better teamwork and engagement, whether teams are local or distributed globally.",
  },
];

const FreeSwitch = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [actIndex, setActIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActIndex(index === actIndex ? null : index);
  };
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <title>
          FreeSWITCH Development Company India | VoIP Solutions - Ayanshtech
        </title>
        <meta
          name="description"
          content="Expert FreeSWITCH Application Development Services in India. Build custom VoIP, video conferencing & real-time communication solutions with 24/7 support."
        />

        <meta name="copyright" content="Ayanshtech Solutions" />
        <meta
          property="og:title"
          content="FreeSWITCH Development Company India | VoIP Solutions - Ayanshtech"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/freeswitch"
        />
        <meta
          property="og:description"
          content="Expert FreeSWITCH Application Development Services in India. Build custom VoIP, video conferencing & real-time communication solutions with 24/7 support."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@Ayanshtech" />
        <meta
          name="twitter:title"
          content="FreeSWITCH Development Company India | VoIP Solutions - Ayanshtech"
        />
        <meta
          name="twitter:description"
          content="Expert FreeSWITCH Application Development Services in India. Build custom VoIP, video conferencing & real-time communication solutions with 24/7 support."
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <link rel="canonical" href="https://ayanshtechnology.com/freeswitch" />
      </Helmet>
      <div className=" flex flex-col items-center justify-center p-4">
        <div className="  w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16 mt-6">
            <div className="lg:w-3/4  lg:text-left p-6 ">
              <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                FreeSWITCH Application Development Services in India
              </h2>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                Reimagine your business communication with FreeSWITCH
                Application Development Services in India by Ayanshtech — your
                trusted partner for advanced, scalable, and secure telecom
                solutions.
              </p>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                We specialize in custom FreeSWITCH development to help
                businesses build next-gen PBX systems, Class 5 SoftSwitches, IVR
                solutions, Session Border Controllers (SBCs), voice gateways,
                video conferencing platforms, and unified communication (UC)
                systems that deliver exceptional performance and flexibility.
              </p>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                With 7+ years of proven expertise, our FreeSWITCH developers in
                India design and deploy high-performance telecom architectures
                that support multiple protocols, advanced codecs, and end-to-end
                encryption. Whether you need cloud-based communication APIs,
                custom FreeSWITCH modules, or enterprise-grade integrations, we
                provide fully tailored solutions to enhance your telecom
                ecosystem. At Ayanshtech, we focus on creating communication
                systems that are reliable, secure, and easy to scale — enabling
                seamless connectivity across devices and platforms. Our
                FreeSWITCH development services ensure improved call quality,
                high availability, and cost-effective deployment to power your
                business communications.
              </p>
              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex justify-center  mb-12 lg:mb-0 mt-5">
              <img
                src="\assets\images\headerSection\hireFreeSwitchDev\img1.png"
                alt="FreeSWITCH Application Development Services in India"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-10">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of FreeSWITCH Solutions
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Ayanshtech crafts both single and multi-tenant platforms with
            FreeSWITCH, integrating features like voicemail, intercom, and group
            calling functionalities.
          </p>
        </div>

        <div className=" p-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Voice Mail</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon2.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Multi-Tenant Support</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">IVR – Interactive Voice Response</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Flexible CDR (Call Detail Records) System
              </p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">SLA – Shared Line Appearance</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Dial Groups</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Call Groups</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Conferencing</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Intercom</p>
            </div>

            {/* New features */}
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Call Recording</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon11.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Call Parking</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon12.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Call Transfer</p>
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-10">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Our FreeSWITCH Development Services
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Harness the power of FreeSWITCH to build cutting-edge applications
            and streamline communication infrastructures. Simplify complex
            software systems and deliver robust, feature-rich solutions tailored
            to your needs.
          </p>
        </div>

        <div className=" p-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="\assets\images\headerSection\hirefreeSwitchDev\img2.png"
                alt="Laptop with graph"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon1.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Efficiently manage high volumes of voice and video calls
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon10.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Build scalable multi-tenant VoIP platforms for diverse needs
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon11.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Design applications that seamlessly interact with users or
                    systems
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon12.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Handle thousands of simultaneous calls with ease
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon13.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Automate critical business workflows for enhanced efficiency
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className=" rounded-3xl">
          <div className="text-center my-5">
            <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
              Empower Your Business with FreeSWITCH Solutions
            </h2>
            <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-medium mt-4 max-w-6xl mx-auto">
              At Ayanshtech, we deliver tailored communication platforms
              designed to streamline operations and enhance customer engagement.
              Explore our VoIP services that empower small businesses with
              advanced communication capabilities, including:
            </p>
          </div>

          <div className=" p-8 ">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Item 1 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Voice Gateway</h3>
                <p className="text-lg">
                  Leverage FreeSWITCH to bridge enterprise VoIP systems with
                  telecom providers for seamless voice communication.
                </p>
              </div>

              {/* Item 2 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Audio/Video Conferencing</h3>
                <p className="text-lg">
                  Build advanced platforms for high-quality voice and video
                  conferencing to create immersive meeting experiences.
                </p>
              </div>

              {/* Item 3 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Session Border Controller</h3>
                <p className="text-lg">
                  Protect your network infrastructure while enabling secure and
                  reliable VoIP call processing.
                </p>
              </div>

              {/* Item 4 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Class 5 SoftSwitch</h3>
                <p className="text-lg">
                  Develop feature-rich Retail SoftSwitch systems for efficient
                  routing and comprehensive billing capabilities.
                </p>
              </div>

              {/* Item 5 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">PBX Solutions</h3>
                <p className="text-lg">
                  Simplify enterprise communication with IP Hosted PBX systems
                  built on FreeSWITCH technology.
                </p>
              </div>

              {/* Item 6 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">IVR Systems</h3>
                <p className="text-lg">
                  Create intelligent and interactive IVR solutions to enhance
                  customer engagement and automate communication workflows.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-green-50  p-4 mb-12 rounded-3xl">
          {/* Title Section */}
          <h2 className="text-center text-3xl sm:text-3xl md:text-5xl lg:text-5xl font-bold text-black mb-6">
            Comprehensive FreeSWITCH Solutions
          </h2>
          <p className="text-center text-base sm:text-lg md:text-xl text-gray-700 mb-8">
            Discover how FreeSWITCH enhances modern communication with its
            versatile features and solutions tailored for businesses of all
            sizes.
          </p>

          {/* Navigation Bar */}
          <div className="flex justify-center flex-wrap gap-6 sm:gap-8 mb-4 w-full">
            {pointsData.map((point, index) => (
              <button
                key={index}
                className={`text-base sm:text-lg font-medium ${
                  activeIndex === index
                    ? "text-blue-600 underline"
                    : "text-gray-500"
                }`}
                onClick={() => setActiveIndex(index)}
              >
                {point.title}
              </button>
            ))}
          </div>

          {/* Content Section */}
          <div className="text-center max-w-5xl mx-auto p-4 border-gray-300">
            <p className="text-base sm:text-lg md:text-xl text-gray-600 mt-4">
              {pointsData[activeIndex].content}
            </p>
          </div>
        </div>

        <div className=" p-6 sm:p-8 md:p-12 lg:p-16 -50 w-full rounded-3xl">
          <div className="text-center mb-8">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Expert Consulting for VoIP and Communication Solutions
            </h1>
            <p className="text-gray-600 sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto">
              At Ayanshtech, we specialize in providing tailored consulting and
              ongoing support for VoIP systems and communication solutions. From
              system setup to optimization, our team ensures seamless
              integration and scalability, helping businesses thrive in their
              communication infrastructure.
            </p>
          </div>

          <div className="mb-8 text-left">
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Our team offers comprehensive consulting and ongoing support for
              your VoIP infrastructure, ensuring that your communication systems
              are robust, scalable, and tailored to your specific needs. Below
              are some of the services we provide:
            </p>
            <ul className="list-disc pl-8 sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto">
              <li>System architecture and design</li>
              <li>Deployment and integration</li>
              <li>Regular updates and system optimization</li>
              <li>Technical support and problem-solving</li>
              <li>Custom feature development</li>
              <li>Employee training and knowledge transfer</li>
            </ul>
          </div>

          <div className="text-center">
            <button
              onClick={scrollToContact}
              className="bg-blue-600 hover: hover:text-blue-600 hover:bg-white hover:border hover:border-blue-600 text-white font-semibold py-3 px-6 rounded-full text-lg transition duration-300"
            >
              Schedule a Free Consultation Today!
            </button>
          </div>
        </div>

        <div className="max-w-3xl mx-auto p-6 py-20 w-full ">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
            FAQs
          </h2>
          {FreeSwitchDevelopersFaqs.map((faq, index) => (
            <div key={index} className="border-b ">
              <button
                onClick={() => toggleFAQ(index)}
                className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                  actIndex === index
                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                    : ""
                }`}
              >
                <span className="text-lg">{faq.question}</span>
                <span className="text-2xl">
                  {actIndex === index ? "-" : "+"}
                </span>
              </button>
              {actIndex === index && (
                <div className="p-4 text-gray-700">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>

        <div id="contact-section">
          {" "}
          <ContactUs />
        </div>
      </div>
    </>
  );
};

export default FreeSwitch;
